<div class="card">
  <form (ngSubmit)="save()" #from="ngForm" class="form d-flex flex-column justify-content-between">
    <div class="cardbody">
      <div class="main-setting h-100">
        <div class="container-fluid h-100">
          <div class="row h-100 hr">
            <div class="col-lg-12 h-100">
              <setting-detail-resource></setting-detail-resource>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <ssg-button
        [disabled]="!from.form.valid"
        buttontype="submit"
        size="medium"
        class="btnsaveform"
        icon="icon-content-save-outline"
        label="{{ 'General.Save' | translate }}">
      </ssg-button>
    </div>
  </form>
</div>
